import {ApiResponse} from 'se-resource-types/dist/lib/common';
import {createFeature, createReducer, on} from '@ngrx/store';
import {OrderHistoryActions} from './order-history.actions';
import {PaginationParameters} from 'app/models/pagination-parameters';
import {Sale} from 'app/data/models/sale';

export const ORDER_HISTORY_FEATURE_KEY = 'orderHistory';

export const DEFAULT_ORDERS_PAGINATION_PARAMS: PaginationParameters = {
  currentPage: 1,
  limit: 10,
};

export interface OrderHistoryState {
  ordersPage: ApiResponse<Sale[]> | undefined;
  pagination: PaginationParameters;
}

export const initialOrderHistoryState: OrderHistoryState = {
  ordersPage: undefined,
  pagination: {...DEFAULT_ORDERS_PAGINATION_PARAMS},
};

export const orderHistoryReducer = createReducer(
  initialOrderHistoryState,

  on(OrderHistoryActions.loadOrders, (state, {params}) => ({...state, pagination: params, ordersPage: undefined})),

  on(OrderHistoryActions.searchOrders, (state, {search}) => ({...state, pagination: {...state.pagination, search}})),

  on(OrderHistoryActions.goToPage, (state, {params}) => ({...state, pagination: {...state.pagination, ...params}})),

  on(OrderHistoryActions.loadOrdersSuccess, (state, {ordersPage}) => {
    return {
      ...state,
      ordersPage,
      pagination: {...state.pagination, total: ordersPage.metadata?.pagination?.total || 0},
    };
  })
);

export const orderHistoryFeature = createFeature({
  name: ORDER_HISTORY_FEATURE_KEY,
  reducer: orderHistoryReducer,
});

export const {name, reducer, selectOrdersPage, selectPagination} = orderHistoryFeature;
